import AnimatedModal from './AnimatedModal'

export default AnimatedModal
